import { useTranslation } from 'react-i18next'

const FIRST_VISIT_KEY = 'opakor_first_visit'
const FEEDBACK_DISMISSED_KEY = 'opakor_feedback_dismissed'
const FEEDBACK_FORM_URL = 'https://forms.gle/p2WSd5rRojkwU3ce8'
const MIN_DAYS = 7

function shouldShow(): boolean {
  if (localStorage.getItem(FEEDBACK_DISMISSED_KEY)) return false
  const first = localStorage.getItem(FIRST_VISIT_KEY)
  if (!first) {
    localStorage.setItem(FIRST_VISIT_KEY, String(Date.now()))
    return false
  }
  const elapsed = Date.now() - Number(first)
  return elapsed >= MIN_DAYS * 24 * 60 * 60 * 1000
}

interface FeedbackModalProps {
  onClose: () => void
}

export const FeedbackModal = ({ onClose }: FeedbackModalProps) => {
  const { t } = useTranslation()

  const handleDismiss = () => {
    localStorage.setItem(FEEDBACK_DISMISSED_KEY, '1')
    onClose()
  }

  const handleFeedback = () => {
    localStorage.setItem(FEEDBACK_DISMISSED_KEY, '1')
    window.open(FEEDBACK_FORM_URL, '_blank', 'noopener,noreferrer')
    onClose()
  }

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 animate-in fade-in duration-200" onClick={handleDismiss}>
      <div className="bg-bg-surface rounded-2xl shadow-2xl border border-border-default p-6 max-w-sm w-full mx-4 animate-in zoom-in-95 duration-200" onClick={(e) => e.stopPropagation()}>
        <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-accent/10 flex items-center justify-center">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-accent">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
          </svg>
        </div>
        <h3 className="text-lg font-semibold text-fg-primary text-center mb-2">{t('dashboard.feedbackTitle')}</h3>
        <p className="text-sm text-fg-muted text-center mb-6">{t('dashboard.feedbackDescription')}</p>
        <div className="flex flex-col gap-2">
          <button
            onClick={handleFeedback}
            className="w-full py-2.5 bg-accent text-white rounded-lg text-sm font-medium hover:bg-accent/90 transition-colors"
          >
            {t('dashboard.feedbackButton')}
          </button>
          <button
            onClick={handleDismiss}
            className="w-full py-2.5 text-sm font-medium text-fg-muted hover:text-fg-primary hover:bg-interactive-hover rounded-lg transition-colors"
          >
            {t('dashboard.feedbackDismiss')}
          </button>
        </div>
      </div>
    </div>
  )
}

export { shouldShow }
